import axios from "config/axios/base";
import qs from "qs";

export const getInternalReferrals = ({ query = {}, options = null }) =>
	axios.get(`/internal-referral?${qs.stringify(query)}`, options);
export const getInternalReferralsDrafts = ({ query = {}, options = null }) =>
	axios.get(`/internal-referral/draft?${qs.stringify(query)}`, options);
export const updateInternalReferral = ({ params = {}, body = {}, options = null }) =>
	axios.patch(`/internal-referral/${params?.id}`, body, options);
export const postInternalReferralRetryUpdate = ({ params = {}, body = {}, options = null }) =>
	axios.post(`/internal-referral/${params?.id}/retry-update`, body || {}, options);

export const postInternalReferralRetryOrderPdf = ({ params = {}, body = {}, options = null }) =>
	axios.post(`/internal-referral/${params?.id}/retry-order-pdf`, body || {}, options);

/** Requisition amend publish (plan/final submit-update). */
export const postInternalReferralRequisitionSubmitUpdate = ({ params = {}, body = {}, options = null }) =>
	axios.post(`/internal-referral/${params?.id}/submit-update`, body || {}, options);

/** Discard draft revision (same semantics as orders). */
export const deleteInternalReferralRequisitionDraft = ({ params = {}, options = null }) =>
	axios.delete(`/internal-referral/${params?.id}/requisition-draft`, options);

/** Requisition edit: draft lock, can_edit, revision (GET by referral note id). */
export const getInternalReferralEditEligibility = ({ params = {}, options = null }) =>
	axios.get(`/internal-referral/${params?.id}/edit-eligibility`, options);

export const getInternalReferralRequisitionAmendments = ({ params = {}, query = {}, options = null }) => {
	const q = Object.keys(query).length > 0 ? `?${qs.stringify(query)}` : "";
	return axios.get(`/internal-referral/${params?.id}/amendments${q}`, options);
};

export const getInternalReferralRequisitionVersions = ({ params = {}, query = {}, options = null }) => {
	const q = Object.keys(query).length > 0 ? `?${qs.stringify(query)}` : "";
	return axios.get(`/internal-referral/${params?.id}/versions${q}`, options);
};

export const getInternalReferralRequisitionRevisionFields = ({ params = {}, query = {}, options = null }) => {
	const q = Object.keys(query).length > 0 ? `?${qs.stringify(query)}` : "";
	return axios.get(`/internal-referral/${params?.id}/revision-fields${q}`, options);
};

export const getInternalReferralRequisitionDraftPreview = ({ params = {}, query = {}, options = null }) => {
	const q = Object.keys(query).length > 0 ? `?${qs.stringify(query)}` : "";
	return axios.get(`/internal-referral/${params?.id}/requisition-draft-preview${q}`, options);
};

export const getInternalReferralSingleDepartmentMembers = ({ params = {}, query = {}, options = null }) =>
	axios.get(`/internal-referral/${params.id}/members?${qs.stringify(query)}`, options);
export const getInternalReferralSingleDepartmentCases = ({ params = {}, query = {}, options = null }) =>
	axios.get(`/internal-referral/${params.id}/cases?${qs.stringify(query)}`, options);
